export default __webpack_public_path__ + "static/media/04.27472d7d.jpg";